import {cs} from "../../../../../../../../react/chain-services";
import * as React from "react";
import "./checkboxes.scss";
import {css, cx} from "emotion";
import {Checkbox} from "../../../../../../../form/checkbox/checkbox";
import {consumeContext} from "@common/react/context";
import {filterControlTypes, filterEventTypes, serializeFilterValue, trackFilterEvent} from "@common/utils/track-filter-event";

export const Checkboxes = ({state, data, theme, trackingLabel}) =>
    cs(consumeContext("filterTrackingType"), ({filterTrackingType}) => {
        const inputTheme = theme.general.components;

        // reports the whole selection after the toggle, not just the box that was hit
        const track = (values) =>
            trackFilterEvent({
                label: trackingLabel,
                eventType: filterEventTypes.selected,
                value: (values ?? []).map((v) => v || "Blank / Empty"),
                type: filterTrackingType ?? filterControlTypes.select,
            });

        return (
            <div
                className={cx("checkboxes-j53")}
                style={{
                    border: `${inputTheme.inputBorderWidth}px solid ${inputTheme.inputBorderColorRGB}`,
                    "border-radius": `${inputTheme.inputCornerRadius}px`,
                }}
            >
                {data?.map((d, i) => {
                    const selected = state.value?.includes(d);
                    return (
                        <div
                            key={i}
                            className={cx("checkbox-item", {selected})}
                            style={{
                                color: `${inputTheme.inputTextColorRGB}`,
                                "fontFamily": `${theme.general.canvas.fontFamily || "Roboto"}, sans-serif`,
                            }}
                        >
                            {Checkbox({
                                state: {
                                    value: selected,
                                    onChange: () => {
                                        const current = state.value ?? [];
                                        track(selected ? current.filter((e) => e !== d) : [...current, d]);
                                        state.change((list) => (selected ? list.filter((e) => e !== d) : [...list, d]));
                                    },
                                },
                                background: theme.general.buttons.primaryButton.backgroundColorRGB,
                            })}
                            {d || "Blank / Empty"}
                        </div>
                    );
                })}
            </div>
        );
    });
